import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as common from '../../common'

import * as excel from './excel'
import * as integrationRunDialog from './integration-run-dialog'

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.table.Component,
    ds.tabs.floatingHorizontal.Component,
    ds.tabs.tab.Directive,
    ds.layout.page.child.header.Component,
    ds.button.Component,
    ds.overlay.centered.Component,
    common.uploadDataDialog.Component,
    integrationRunDialog.Component,
  ],
  selector: 'atn-dms-catalog-page',
  standalone: true,
  styleUrls: ['./page.component.scss'],
  templateUrl: './page.component.html',
})
export class Page {
  /** Connector execution state for the active app zone. */
  public readonly connectorsEc = ngCore.inject(
    state.integrations.connectors.Collection,
  )

  /** @see {@link state.dms.entities.Collection} */
  public readonly entitiesEc = ngCore.inject(state.dms.entities.Collection)
  /** @see {@link state.dms.dimensions.Collection} */
  public readonly dimensionsEc = ngCore.inject(state.dms.dimensions.Collection)
  /** @see {@link state.dms.snapshots.Collection} */
  public readonly snapshotsEc = ngCore.inject(state.dms.snapshots.Collection)
  /** @see {@link state.dms.enums.Collection} */
  public readonly enumsEc = ngCore.inject(state.dms.enums.Collection)

  /** Canonical table input for the Dimensions catalog tab. */
  public readonly dimensionsTableConfig = {
    collection: this.dimensionsEc,
    view: {
      search: true,
      title: 'Dimensions',
    },
  } satisfies ds.table.ec.Config.Input<state.dms.dimensions.TypeParams>

  /** Canonical table input for the Entities catalog tab. */
  public readonly entitiesTableConfig = {
    collection: this.entitiesEc,
    view: {
      search: true,
      title: 'Entities',
    },
  } satisfies ds.table.ec.Config.Input<state.dms.entities.TypeParams>

  /** Canonical table input for the Snapshots catalog tab. */
  public readonly snapshotsTableConfig = {
    collection: this.snapshotsEc,
    view: {
      search: true,
      title: 'Snapshots',
    },
  } satisfies ds.table.ec.Config.Input<state.dms.snapshots.TypeParams>

  /** Canonical table input for the Enums catalog tab. */
  public readonly enumsTableConfig = {
    collection: this.enumsEc,
    view: {
      search: true,
      title: 'Enums',
    },
  } satisfies ds.table.ec.Config.Input<state.dms.enums.TypeParams>

  /** Determines whether the upload data dialog is displayed */
  public presentUploadDataDialogSg = ngCore.signal(false)

  /**
   * Update signal @see {@link presentUploadDataDialogSg} on upload button
   * click
   */
  public toggleIsUploadDataDialogDisplayed(): void {
    this.presentUploadDataDialogSg.update(isDisplayed => !isDisplayed)
  }

  /**
   * Generate excel file and download it
   */
  public downloadClickHandler(): void {
    const entities =
      this.entitiesEc.plugins.currentListPlugin.feature.selectors.entities.asSignal()
    const workbook = excel.generator.generate(entities)
    void workbook.saveAs('DMS Upload Template')
  }

  /** Opens the connector run launcher stored in integration state. */
  public openIntegrationLauncher(): void {
    this.connectorsEc.runs.actions.openLauncher
      .from('DmsCatalog.RunIntegrations.Clicked')
      .dispatch()
  }
}
